import "../../pages/new/new.scss"


import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Container, TextField, Button, Box } from '@mui/material';
import { getNoStudentCourses , addNewCourse} from '../../services/studentService';
import { getAllTerms } from '../../services/termService';
import { Link } from "react-router-dom";
import { DataGrid } from '@mui/x-data-grid';

export const UndertakingCourse = ({ studentId,studentData, onChange, viewMode }) => {
    const [student, setStudent] = useState(studentData);
    const [errors, setErrors] = useState({});
    const [options, setOptions] = useState([]);
    const [newCourses, setNewCourses] = useState({
        id:'',//this is term_course_id
        termName:'',
        courseName: '',
        instructorNames: '',
        attendance:'',
        classes:'',
        gradeReceived:''
       
    });
    const [selectedcourseId, setSelectedCourseId] = useState(null);

    const [selectedId, setSelectedId] = useState(null);
    const fetchTerms = async () => {
        try {
            const data = await getAllTerms();
           // console.log(data);
            setOptions(data.data);
        } catch (err) {

        }
    };
    const fetchNewCourseList = async (studentid) => {
        try {
           const response = await getNoStudentCourses(studentid);
          //  console.log(response.data)
            setNewCourses(response.data); // Set course details from API response
        } catch (error) {
            console.error('Error fetching course:', error);
        }
    };
    useEffect(() => {
        setStudent(studentData);
        fetchNewCourseList(studentId);
    }, [studentData]);
  //  console.log(studentData);
    const handleAddCourse = async (id) => {
        try {

            const courseData = {
                "studentId": studentId,
                "termCourseId": id
            }
            const response = await addNewCourse(courseData);
          //  console.log(response);
            onChange();
            
        } catch (error) {
            console.log('Error saving termCourse. Please try again later.');
            console.log(error);
        }
    };
    //
    const columns = React.useMemo(
        () => [
          { field: 'term_name', headerName: 'Term Name', width: 150 },
          { field: 'course_name', headerName: 'Course Name', width: 150 },
          { field: 'instructor_names', headerName: 'Instructors', width: 150 },
          { 
            field: 'attendance', 
            headerName: 'Attendance (%)', 
            width: 150,
            type: 'number',
            renderCell: (params) => {
              // Extract the values and use defaults if they are undefined
              const { attendance = 0, classes = 1 } = params.row || {};
              
              // Log the params and the values for debugging
             // console.log('params:', params);
             // console.log('attendance:', attendance);
            //  console.log('classes:', classes);
      
              // Ensure classes is not zero to avoid division by zero
              const percentage = classes > 0 ? (attendance / classes) * 100 : 0;
      
              // Return the computed percentage as a string to show in the grid
              return percentage.toFixed(2);
            }
          },
          { field: 'grade_received', headerName: 'Grade Received', width: 150 }
        ],
        []
      );
    const actionColumn = [{
        field: "action", headerName: "Action", width: 200,
        renderCell: (params) => {
            const { id } = params.row;
            return (
                <div className="cellAction">
                    <div className="viewButton"><Link to={{ pathname: `/termcourses/view-termcourse/${id}` }} style={{ textDecoration: "none" }}>View</Link></div>
                    <div className="editButton"><Link to={{ pathname: `/termcourses/edit-termcourse/${id}` }} style={{ textDecoration: "none" }}>Edit</Link></div>
                </div>
            );
        }
    }]

    const columnsNew = React.useMemo(
        () => [
            { field: 'term_name', headerName: 'Term Name', width: 150 },
            { field: 'course_name', headerName: 'Course Name', width: 150 },
            { field: 'instructor_names', headerName: 'Instructors', width: 150 },
            
        ],
        []
    );
    const actionNewColumn = [{
        field: "action", headerName: "Action", width: 200,
        renderCell: (params) => {
            const { id } = params.row;
            return (
                <div className="cellAction">
                    <div className="addButton"><button  onClick={() => handleAddCourse(id)}>Add</button></div>
                    
                </div>
            );
        }
    }]
    return (
        <div className="bottom">
            <div className="left"></div>
            <div className="right">
                <div className="datatable" >

                    <DataGrid
                        rows={studentData}
                        columns={columns.concat(actionColumn)}
                        initialState={{
                            pagination: {
                                paginationModel: { page: 0, pageSize: 10 },
                            },
                        }}
                        pageSizeOptions={[5, 10]}
                    //checkboxSelection
                    />

                </div>


                <div className="datatable" >
                        <h2>Add New Course</h2>
                    <DataGrid
                        rows={newCourses}
                        columns={columnsNew.concat(actionNewColumn)}
                        initialState={{
                            pagination: {
                                paginationModel: { page: 0, pageSize: 10 },
                            },
                        }}
                        pageSizeOptions={[5, 10]}
                    //checkboxSelection
                    />

                </div>


            </div>
        </div>
    );
};